import { IconButton } from '@material-ui/core';
import { Print } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import ActionTooltip from './ActionTooltip';

type CarDetailPrintProps = {
  color?: 'primary' | undefined;
  toolTipPosition?: 'bottom' | 'left' | undefined;
};

const ActionCarDetailPrint = ({ toolTipPosition, color }: CarDetailPrintProps) => {
  const { t } = useTranslation();
  return (
    <ActionTooltip title={t('navigation.print')} position={toolTipPosition}>
      <IconButton size="small" onClick={() => window.print()} color={color}>
        <Print />
      </IconButton>
    </ActionTooltip>
  );
};

export default ActionCarDetailPrint;
